import { Stack, TextField, Typography, Button, InputAdornment } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { AddContactForm } from "./AddContactForm";

export const AddClientForm = ({ formValues, handleInputChange, reset, title }) => {

    const { name, tel, email, fax, movil, cif, address, cp, bank } = formValues;
    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/client')
    }

    return (
        <Stack spacing={5} pt={3} pb={3} pl={3} pr={3} width='100%' minWidth={650}>
            <Typography textAlign='center' variant="h5" color="primary">{title} Cliente</Typography>
            <Stack flexDirection='row' flexWrap='wrap' justifyContent='space-between' gap={2} >
                <TextField
                    label="Nombre empresa"
                    type="search"
                    variant="standard"
                    name='name'
                    value={name}
                    onChange={handleInputChange}
                    required
                    sx={{ width: '30%' }}
                />
                <TextField
                    label="Móvil"
                    type="search"
                    variant="standard"
                    name="movil"
                    value={movil || ''}
                    onChange={handleInputChange}
                    sx={{ width: '30%' }}
                />
                <TextField
                    label="Teléfono"
                    type="search"
                    variant="standard"
                    name='tel'
                    value={tel || ''}
                    onChange={handleInputChange}
                    sx={{ width: '30%' }}
                    required
                />
                <TextField
                    label="Email"
                    type="email"
                    variant="standard"
                    name='email'
                    value={email || ''}
                    onChange={handleInputChange}
                    sx={{ width: '30%' }}
                />
                <TextField
                    label="Fax"
                    type="search"
                    variant="standard"
                    name='fax'
                    value={fax || ''}
                    onChange={handleInputChange}
                    sx={{ width: '30%' }}
                />
                <TextField
                    label="CIF/NIF"
                    type="search"
                    variant="standard"
                    name="cif"
                    value={cif || ''}
                    onChange={handleInputChange}
                    sx={{ width: '30%' }}
                />
                <Stack flexDirection='row' width='100%' justifyContent='space-around'>
                    <TextField
                        label="Dirección"
                        type="search"
                        variant="standard"
                        fullWidth
                        name="address"
                        value={address || ''}
                        onChange={handleInputChange}
                    />
                </Stack>

                <TextField
                    label="Cuenta bancaria"
                    variant="standard"
                    sx={{ width: '80%' }}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">ES</InputAdornment>
                    }}
                    inputProps={{ maxLength: 22, minLength: 22, pattern: "[0-9]{22,22}" }}
                    name='bank'
                    value={bank || ''}
                    onChange={handleInputChange}
                />
                <TextField
                    label="CP"
                    variant="standard"
                    sx={{ width: '15%' }}
                    name='cp'
                    value={cp || ''}
                    onChange={handleInputChange}
                />
            </Stack>
            <AddContactForm formValues={formValues} handleInputChange={handleInputChange} />
            <Stack flexDirection='row' flexWrap='wrap' justifyContent='flex-end' gap={5}>
                <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={handleCancel}>Cancelar</Button>
                {(title === 'Añadir nuevo') && <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={reset}>Reset</Button>}
                <Button sx={{ width: '100px' }} variant="contained" size='small' type='submit'>{(title.split(' ')[0]=== 'Editar') ? 'Guardar' : 'Añadir'}</Button>
            </Stack>
            <Stack width='95%'>
                <Typography variant="caption" >* campos obligatorios</Typography>
            </Stack>
        </Stack>
    )
}
